import script from "./OnboardingAiWebsiteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiWebsiteStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiWebsiteStep.vue?vue&type=style&index=0&id=bf4d13d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4d13d8"]])

export default __exports__